// @flow
import OfficeInfo from './OfficeInfo';
export default OfficeInfo;
